import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../../icon/icon.component';

@Component({
    selector: 'nw-side-menu-call-to-action',
    templateUrl: './side-menu-call-to-action.component.html',
    styleUrls: ['./side-menu-call-to-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class SideMenuCallToActionComponent {
    @Input() label!: string;
}
